export default "__VITE_ASSET__BTTqkrHL__"